(function () {
  angular.module('app.response-to-intervention-analytics.quickview', []);

})();